module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG3a6da941dc5277f542e1d6b356fcf63e.3a6da941.png";